import React, { Component } from 'react'

import './App.css'

import Routes from './routes'

class App extends Component {
  componentDidMount() {
    document.title = 'Orquestrador Docs'
  }

  render() {
    return (
      <div className="App">
        <Routes />
      </div>
    )
  }
}

export default App
